/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import { slugifyText } from 'helpers/utils';
import { isEmpty } from 'lodash';

const Legend = ({
  indexScale,
  title,
  setLayerVisible,
  header = true,
  area
}) => {
  const map = useMap();
  const [showLegend, setShowLegend] = useState(true); // State to control the Legend
  // const slug = slugifyText(title);
  useEffect(() => {
    if (map && showLegend) {
      // Check if showLegend is true before adding the control
      const legend = L.control({ position: 'bottomright' });

      let labels = [];
      header &&
        indexScale[0]?.unit &&
        labels.push(` <div class='legend-title pb-1 pt-1' style="margin-bottom:5px">
        <div class='d-flex flex-row justify-content-between align-items-center p-2 pb-0 gap-3'> 
        <h6 class='p-0 m-0'>${title}</h6>
        ${
          indexScale[0]?.unit
            ? `<p class='p-0 m-0'>unit (${indexScale[0]?.unit})</p>`
            : ''
        }
        </div></div>`);
      for (let i = 0; i < indexScale.length; i++) {
        labels.push(`
        <div>
        <div>
      <i class='legend-bg' style="background-color:${
        indexScale[i].bg_color
      }"></i>
      <span>${indexScale[i].legend}${
          area !== undefined && area !== '' ? ` (${area[i]})` : ''
        }</span>
    </div>
      </div>
          `);
      }

      legend.onAdd = () => {
        const div = L.DomUtil.create(
          'div',
          'info legend rounded overflow-hidden'
        );
        div.innerHTML = labels.join('');
        return div;
      };

      legend.addTo(map);

      return () => legend.remove();
    }
  }, [map, showLegend, indexScale, title, area]);

  useEffect(() => {
    const toggle = L.control({ position: 'topright' });

    toggle.onAdd = () => {
      const div = L.DomUtil.create(
        'div',
        'px-2 pb-1 leaflet-custom-control rounded'
      );

      const layerToggleEl = `
        <div class="form-check mb-0 d-flex align-items-center">
          <input
            class="form-check-input me-2"
            type="checkbox"
            id="layer-toggle-${'slug'}"
          />
          <label class="form-check-label mb-0 mt-1" for="legend-toggle">
            Layer
          </label>
        </div>`;

      const legendToggleEl = `
          <div class="form-check mb-0 d-flex align-items-center">
            <input
              class="form-check-input me-2"
              type="checkbox"
              id="legend-toggle-${'slug'}"
            />
            <label class="form-check-label mb-0 mt-1" for="legend-toggle">
              Legend
            </label>
          </div>`;

      div.innerHTML = `
    <div class="d-flex align-items-center gap-3">
      ${layerToggleEl}
      ${legendToggleEl}
    </div>`;

      // Set the defaultChecked and onChange properties using JavaScript
      const layerToggle = div.querySelector(`#layer-toggle-${'slug'}`);
      if (layerToggle) {
        layerToggle.defaultChecked = true;
        layerToggle.onchange = () => setLayerVisible(prev => !prev);
      }

      const legendToggle = div.querySelector(`#legend-toggle-${'slug'}`);
      if (legendToggle) {
        legendToggle.defaultChecked = true;
        legendToggle.onchange = () => setShowLegend(prev => !prev);
      }

      return div;
    };

    toggle.addTo(map);

    return () => toggle.remove();
  }, [map]);

  return null;
};

export default Legend;
